var fileUploadInit = function () {
    //Adds modrnizr test for fileapi
    Modernizr.addTest("fileapi", function () {
        return (typeof window.File != "undefined");
    });

    //This is a fix for accessibility ticket https://islington.atlassian.net/browse/AC-1144
    if ($("#prefabConfirmation").hasClass("m-alert-success")) {
        document.title = "Request submitted - " + document.title;
    }

    if (!Modernizr.fileapi)
        $('.m-fileUploadWrapper').addClass('is-fileapiNotSupported');
    
    let screenreaderAlert;
    let uploadButton = $('a[data-file-select]');

    if (uploadButton.length) {
        screenreaderAlert = $("<div class='sr-only' role='alert' />");
        $('body').append(screenreaderAlert);
    }

    uploadButton.on('click', function (e) {
        e.preventDefault();
        var ele = $(this),
            fileInputSelector = ele.attr('href');
        $(fileInputSelector).trigger('click');
    });
    $('input[type=file]').on('change', function (e) {
        var _self = $(this);
        var screenReaderAlertText = ''

        //A fix for IE Edge as it fires change handler for nulling file value and
        //make code cross browser 
        if ((_self.val() == "")
            || !Modernizr.fileapi)
            return;
        //

        var files = _self.get(0).files,
        length = files.length,
        parent = $(this).closest('.m-fileUploadWrapper'),
        fileSelectionButton = parent.find('.m-fileSelect'),
        allSelectedFilesContainer = parent.find('.m-allSelectedFiles'),
        fileContainerHTML = parent.find('.reusableMarkup').html(),
        alertConsole = parent.find('.m-alert'),
        errorContainer = alertConsole.find('[data-errors]'),
        fileFormats = _self.attr('reject') ||
        _self.attr('accept'),
        formatValidationType = islington.checkValidity(_self.attr('reject')) ?
        "reject" : "accept",
        maxFileSize = _self.data('max-size'),
        maxNumberFiles = _self.data('max-number-file'),
        maxFileSizeMsg = _self.data('max-size-msg'),
        maxNumberFilesMsg = _self.data('max-number-file-msg'),
        minNumberFiles = _self.data('min-number-file'),
        minNumberFilesMsg = _self.data('min-number-file-msg'),
        extensionMsg = _self.data('extension-msg'),
        duplicationMsg = _self.data('duplication-msg');
        currentSelectedFilesOnUI = allSelectedFilesContainer.
            find(".m-selectedFileWithUploadButton").
            index(allSelectedFilesContainer.
            find(".m-selectedFileWithUploadButton:last")) + 1,//adding 1 because indexing starts from 0
        filesNameArray = [], errMsg = [];

        //Initializing filesNameArray with all selected files name
        allSelectedFilesContainer.
            find(".m-selectedFileWithUploadButton .m-selectedFile-name").each(
            function () {
                filesNameArray.push(this.innerText);
                });

        for (var i = 0; i < length; i++) {
            var formData = new FormData(),
            file = files[i],
            fileName = file.name,
            fileSize = islington.fileSizeEffectiveUnitCoverter(file.size, true),
            fileSizeMB = (file.size / (1024 * 1024)).toFixed(2),//1024*1024 converts filesize in to MB
            totalFileCount = currentSelectedFilesOnUI + 1,
            selectedFileContainer = $(fileContainerHTML),
            selectedFile = selectedFileContainer.find(".m-selectedFile"),
            selectedFileName = selectedFileContainer.find(".m-selectedFile-name"),
            selectedFileSize = selectedFileContainer.find(".m-selectedFile-size"),
            fileUploadButton = selectedFileContainer.find("[data-upload]"),
            fileCloseButton = selectedFileContainer.find("[data-upload-close]"),
            isExtensionSupported = islington.isFileSupported(file,
                fileFormats, formatValidationType);

            //To do further check whether file extension manually changed to support or not?
            if (isExtensionSupported) {
                var reader = new FileReader(),
                   filenameSplited = fileName.split('.'),
                   fileFormat = filenameSplited[filenameSplited.length - 1].toLowerCase();
                reader.onloadend = function (e) {
                    var arr = (new Uint8Array(e.target.result)).subarray(0, 4),
                        header = "";
                     
                        for (var i in arr) {
                            header += arr[i].toString(16);
                        }
                        var signature = islington.formatSignature[fileFormat],
                            isUndefinedSignature = signature== undefined?
                            true : false;

                        if ((header != signature) &&
                            !isUndefinedSignature) {
                            //allSelectedFilesContainer.append(selectedFileContainer);
                            selectedFileContainer.remove();
                            errMsg.push(fileName + ":File extension does not match the file type!");
                            errorDisplay();
                        }
                  };
                  reader.readAsArrayBuffer(file);
            }

            if (!isExtensionSupported) {
                errMsg.push(fileName + ": " + extensionMsg);
                continue;
            } else if (fileSizeMB > maxFileSize) {
                errMsg.push(fileName + ": " + maxFileSizeMsg);
                continue;
            } else if (totalFileCount > maxNumberFiles) {
                errMsg.push(fileName + ": " + maxNumberFilesMsg);
                break;
            } else if (filesNameArray.indexOf(fileName) >= 0) {
                errMsg.push(fileName + ": " + duplicationMsg);
                continue;
            }

            /*Setting up formdata object*/
            formData.append("fileUploader", file);
            formData.append("formId", $("#FormId").val());
            formData.append("businessId", $("#BusinessId").val());
            formData.append("responseId", $("#ResponseId").val());
            formData.append("topic", $("#Topic").val());
            formData.append("userId", $("#UserId").val());

            //attaching handlers foreach upload and close button 
            fileUploadButton.on('click', uploadFile);
            fileCloseButton.on('click', function (e) {
                e.preventDefault();
                var selectedFileWithUploadButton =
                             $(this).closest('.m-selectedFileWithUploadButton'),
                    isUploadingDone = selectedFileWithUploadButton.
                    hasClass('is-uploadingDone'),
                    isUploading = selectedFileWithUploadButton.
                    hasClass('is-uploading');
                //this removes document when they are only selected state
                if (!isUploadingDone && !isUploading) {
                    selectedFileWithUploadButton.remove();
                    // update alert message for screenreader                
                    screenreaderAlert.text(`A file was removed: ${e.currentTarget.attributes['aria-describedby'].textContent}`);
                    // shift focus to upload button
                    fileSelectionButton.focus();
                } 
                return false;
            });

            //Setting essential filedata and visual info of the file
            selectedFileContainer.addClass("is-selected");
            selectedFile.data("filedata", formData);
            selectedFileName.text(fileName);
            selectedFileName.attr('id', fileName);
            fileUploadButton.attr('aria-describedby', fileName);
            fileCloseButton.attr('aria-describedby', fileName);
            selectedFileSize.text(fileSize);

            allSelectedFilesContainer.append(selectedFileContainer);

            filesNameArray.push(fileName);
            ++currentSelectedFilesOnUI;

            screenReaderAlertText += `A  file was attached: ${fileName}. `;
        }

        // update alert element with attahced file(s) info for screenreader users
        setTimeout(() => {
            screenreaderAlert.text(screenReaderAlertText);
        }, 1000)
        

        //Error Displaying
        errorDisplay();
        function errorDisplay() {
            errorContainer.find('ol').remove();
            if (errMsg.length > 0) {
                alertConsole.removeClass('hide').
                    show();
                errorContainer.append($("<ol>"));
                var errorListElem = errorContainer.find("ol");
                for (i in errMsg) {
                    var error = errMsg[i],
                        lineElem = $("<li>");
                    lineElem.append('<p>' + error + '</p>');
                    errorListElem.append(lineElem);
                }
            } else {
                alertConsole.hide();
            }
        }
        //
        _self.val("");
    });

    function uploadFile(e) {
        e.preventDefault();
        var uploadButton = $(this),
        selectedFileWithUploadButton = uploadButton.closest(".m-selectedFileWithUploadButton"),
        selectedFile = selectedFileWithUploadButton.find(".m-selectedFile"),
        formData = selectedFile.data('filedata'),
        deleteButton = selectedFileWithUploadButton.find(".m-buttonClose"),
        eachUploadErrorContainer = selectedFileWithUploadButton.find("[class*=field-validation]"),
        formSubmitbuttons = uploadButton.closest('form').find('[type=submit]'),
        isUploadProgressStoppedByUser = false;

        eachUploadErrorContainer.removeClass("field-validation-error").addClass(
            "field-validation-valid").text("");
        selectedFile.removeClass("error");
        uploadButton.attr("aria-hidden", "true");
        selectedFileWithUploadButton.removeClass('is-selected').
            addClass('is-uploading');
        ajaxObject = {
            type: "POST",
            url: islington.url.uploadDocument + '?azureFormId=' + $("#ResponseId").val(),
            data: formData,
            contentType: false,
            processData: false,
            success: function (res) {
                selectedFile.data("docId", res.documentId);
                selectedFileWithUploadButton.removeClass("is-selected is-uploading").
                    addClass("is-uploadingDone");
                enableSubmits(formSubmitbuttons);
                screenreaderAlert.text(`A file was successfully uploaded`);
            },
            error: function (xhr, ajaxOptions, thrownError) {
                selectedFileWithUploadButton.removeClass("is-uploading").addClass("is-selected");
                uploadButton.attr("aria-hidden", "false");
                if (!isUploadProgressStoppedByUser) {
                    eachUploadErrorContainer.removeClass("field-validation-valid").addClass(
                        "field-validation-error").text("File upload failed, please try again or contact the service concerned directly.");
                    eachUploadErrorContainer.wrap('<div aria-live="true"></div>');
                    selectedFile.addClass("error");
                }

                isUploadProgressStoppedByUser = false;
                enableSubmits(formSubmitbuttons);

            },
            xhr: function () {
                var xhr = new window.XMLHttpRequest();
                deleteButton.off('click.onServerConnection').
                    on('click.onServerConnection', function (e) {
                        e.preventDefault();
                        var selectedFileWithUploadButton =
                            $(this).closest('.m-selectedFileWithUploadButton'),
                        isUploading = selectedFileWithUploadButton.hasClass("is-uploading"),
                        isUploadingDone = selectedFileWithUploadButton.hasClass("is-uploadingDone"),
                        selectedFile = selectedFileWithUploadButton.find(".m-selectedFile"),
                        formData = selectedFile.data('filedata');
                        if (isUploading) {
                            isUploadProgressStoppedByUser = true;
                            xhr.abort();
                            uploadButton.attr("aria-hidden", "true");
                            enableSubmits(formSubmitbuttons);
                        } else if (isUploadingDone) {
                            var docId = selectedFile.data("docId");
                            deleteDocument(docId, selectedFileWithUploadButton);
                        }
                    });

                xhr.upload.addEventListener("progress", function (evt) {
                    var complete = evt.loaded / evt.total;
                    uploadButton.progressBar(evt.loaded, evt.total);
                    disableSubmits(formSubmitbuttons);
                }, false);

                return xhr;
            }
        };
        //send Ajax for Uploading
        $.ajax(ajaxObject);
    }


    function deleteDocument(docId, selectedFileWithUploadButton) {
        var sure = confirm("Click OK to confirm delete!"),
            selectedFile = selectedFileWithUploadButton.find('.m-selectedFile'),
            eachUploadErrorContainer = selectedFileWithUploadButton.find('[class*=field-validation]');
        if (sure === true) {
            var url = islington.url.deleteDocument + '?azureFormId=' +
                $("#ResponseId").val() + '&documentId=' + docId;
            $.ajax({
                type: "DELETE",
                url: url,
                success: function (res) {
                    console.log("removing from server");
                    selectedFileWithUploadButton.remove();
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    eachUploadErrorContainer.removeClass("field-validation-valid").addClass(
      "field-validation-error").text("Deleting File: " + thrownError);
                    selectedFile.addClass("error");
                }
            });
        }
    }

    function disableSubmits(submitButtons) {
        submitButtons.each(function (e) {
            $(this).attr("disabled", "true").addClass("disabled");
        });
    }

    function enableSubmits(submitButtons) {
        var allUploadsContainer = $(".m-allSelectedFiles"),
        isAnyUploadInProgress = allUploadsContainer.find(".is-uploading").length;
        if (!isAnyUploadInProgress)
            submitButtons.each(function (e) {
                $(this).prop("disabled", false).removeClass('disabled');
            });
    }
    
    $(".is-uploadingDone").each(function () {
        var fileContainer = $(this),
            selectedFile = fileContainer.find('.m-selectedFile'),
            deleteButton = fileContainer.find('[data-upload-close]'),
            docId = selectedFile.data("guid");

        deleteButton.on('click', function () {
            deleteDocument(docId, fileContainer);
            return false;
        });
    });

    $("form").on('submit', function (e) {          
        onSubmitFileUploadValidation(this, e);
    });
};

function onSubmitFileUploadValidation(form, event) {
    var _self = $(form),
            hasFileupload = _self.find(".m-fileUploadWrapper").length ? true : false;

    if (hasFileupload && !$(document.activeElement).hasClass("btn-back")) {
        var minNumberFiles = _self.find("#documentToUpload").data('min-number-file');
        var minNumberFilesMsg = _self.find("#documentToUpload").data('min-number-file-msg');
        var numFilesUploaded = _self.find(".m-selectedFileWithUploadButton.is-uploadingDone").length;
        if (numFilesUploaded < minNumberFiles) {
            alert(minNumberFilesMsg);

            // Update page title if error
            let titleText = document.title;
            if (titleText.includes("Error") == false) {
                titleText = 'Error - ' + titleText;
                document.title = titleText;
            }
            event.preventDefault();
			return false;
        }

            var selectedFiles = _self.find(".m-selectedFileWithUploadButton");
           
            selectedFiles.each(function () {
                var selectedFile = $(this);
                if (selectedFile.hasClass("is-selected")) {
                    var firstDocUpload = selectedFile.find("[data-upload]");
                    var isNotConfirmed = !confirm("You have not uploaded all selected documents, do you want to continue?");
                    if (isNotConfirmed) {
                    event.preventDefault();
                        firstDocUpload.on('focus');
                    }
                    return false;
                }
            });
        }
}